import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { format } from "date-fns";
import React from "react";

export function RosterBreak({ rostered_break }: { rostered_break?: RosteredBreak }) {
  if (!rostered_break) {
    return (
      <div className="text-xs">
        <FontAwesomeIcon icon="coffee" className="mr-1" />
        No break
      </div>
    );
  }
  return (
    <div
      className="text-xs"
      title={format(new Date(rostered_break.start), "h:mm a") + "-" + format(new Date(rostered_break.end), "h:mm a")}
      style={{ textOverflow: "ellipsis" }}
    >
      <FontAwesomeIcon icon="coffee" className="mr-1" />
      <span className="whitespace-nowrap">{format(new Date(rostered_break.start), "h:mm a")}</span>-
      <span className="whitespace-nowrap ">{format(new Date(rostered_break.end), "h:mm a")}</span>
    </div>
  );
}
